import { AssetTypes } from "constants/alo";
import { parents } from '../hierarchy';

interface ILinkedTreeNode extends Hierarchy.IHierarchyItem {
    parent?: ILinkedTreeNode;
}

type Matcher = (node: Hierarchy.IHierarchyItem, term: string) => boolean;

export class HierarchyFilter {

    constructor(private hierarchy: Hierarchy.IHierarchyItem[]) {

    }

    byNode(cb: (node: Hierarchy.IHierarchyItem) => boolean) {

        const nodes: Hierarchy.IHierarchyItem[] = [];

        const keep = (item: ILinkedTreeNode) => {
            if (!item) {
                return;
            }

            item.visible = true;

            item.expanded = true;

            if (cb) {
                cb(item);
            }

            keep(item.parent);
        }

        const mark = (parent: Hierarchy.IHierarchyItem, children: Hierarchy.IHierarchyItem[], found: boolean) => {

            parent.visible = false;

            const match = cb(parent);

            if (match) {
                nodes.push(parent);
            }

            if (match || found) {
                keep(parent);
            }

            children = children || [];

            children.forEach(child => {
                mark(child, child.children, match || found);
            });
        };

        this.hierarchy.forEach(item => {
            if (item && item.children) {
                mark(item, item.children, false);
            }
        });

    }

    filter(term: string, cb?: (item: Hierarchy.IHierarchyItem) => void) {

        // default is search by well name
        let matcher: Matcher = (node: Hierarchy.IHierarchyItem, term: string) => {
            return node.name.toLowerCase().includes(term);
        };

        term = term.toLowerCase();

        if (term.startsWith('id:')) {
            // search by item id
            term = term.substring(3).trim();

            matcher = (node: Hierarchy.IHierarchyItem, term: string) => {
                return node.id.toLowerCase() === term;
            };
        }

        if (term.startsWith('loc:')) {
            // search by item id
            term = term.substring(4).trim();

            matcher = (node: Hierarchy.IHierarchyItem, term: string) => {
                return node.locationId === parseInt(term);
            };
        }

        const wells: Hierarchy.IHierarchyItem[] = [];

        const keep = (item: ILinkedTreeNode) => {
            if (!item) {
                return;
            }

            item.visible = true;

            //item.expanded = true;

            if (cb) {
                cb(item);
            }

            keep(item.parent);
        }

        const mark = (parent: Hierarchy.IHierarchyItem, children: Hierarchy.IHierarchyItem[], found: boolean) => {

            parent.visible = false;

            let match = matcher(parent, term);

            // search matches well name
            if (match && parent.category === AssetTypes.Completion) {
                wells.push(parent);
            }

            if (match || found) {
                keep(parent);
            }

            children = children || [];

            children.forEach(child => {
                mark(child, child.children, match || found);
            });

        };

        this.hierarchy.forEach(item => {
            if (item && item.children) {
                mark(item, item.children, false);
            }
        });

        // expand well nodes that match search term
        wells.forEach(well => {
            parents(well, item => item.expanded = true);
        });
    }

}
